import { type InsuranceCorporateIdentity } from "../types";

export function ZfLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M450.1 256.05C450.1 148.392 363.708 62 256.05 62C149.721 62 62 149.721 62 256.05C62 363.708 148.392 450.1 256.05 450.1C363.708 450.1 450.1 363.708 450.1 256.05ZM103.202 172.316H197.569L119.152 363.708H394.277C362.379 404.91 311.873 430.163 256.05 430.163C160.354 431.492 81.9366 353.075 81.9366 256.05C81.9366 225.48 88.5822 196.24 103.202 172.316ZM369.024 256.05V232.126H321.176V172.316H410.227C423.518 197.569 431.492 225.48 431.492 257.379C431.492 287.949 423.518 317.189 410.227 342.442H185.607L264.025 149.721H119.152C151.05 108.519 201.557 83.2658 257.379 83.2658C313.202 83.2658 363.708 109.848 395.607 149.721H270.67V325.164H322.505V256.05H369.024Z"
        fill="white"
      />
    </svg>
  );
}

export const Zf: InsuranceCorporateIdentity = {
  id: "zf",
  name: "ZF BKK",
  logo: ZfLogo,
  backgroundColor: "#0E7ABF",
  textColor: "#FFFFFF",
  wildcard: "zf",
  type: "statutory",
};
